import React, { FC } from 'react'
import { LocaleCodes } from '../../../../constants/localization.constants'
import { WeChatPopUp, cnWeChatPopOver } from '../../../../utils/cn.utils'
import Typography from '../../typography'
import { FooterSocial } from '../style'
import {
  Facebook_Logo,
  Instagram_logo,
  Linkedin_Logo,
  Toutiao_Logo,
  Twitter_Logo,
  Wechat_Logo,
  Weibo_Logo,
  Youku_Logo,
  Youtube_Logo,
} from '../utils/footerLogos'

type Props = {
  socialData: any
  langCode: string
}

const SocialIcons: FC<Props> = ({ socialData, langCode }) => {
  const CNLogos = (
    <>
      <li>
        <a href="javascript:void(0)" onClick={cnWeChatPopOver} data-target="popover_wechat">
          {Wechat_Logo}
        </a>
      </li>
      <li>
        <a href={socialData.WEIBO} target="_blank">
          {Weibo_Logo}
        </a>
      </li>
      <li>
        <a href={socialData.TOUTIAO} target="_blank">
          {Toutiao_Logo}
        </a>
      </li>
      <li>
        <a href={socialData.LINKEDIN} target="_blank">
          {Linkedin_Logo}
        </a>
      </li>
      <li>
        <a href={socialData.YOUKU} target="_blank">
          {Youku_Logo}
        </a>
      </li>
    </>
  )

  const logos = (
    <>
      <li>
        <a href={socialData.FACEBOOK} target="_blank">
          {Facebook_Logo}
        </a>
      </li>
      <li>
        <a href={socialData.LINKEDIN} target="_blank">
          {Linkedin_Logo}
        </a>
      </li>
      <li>
        <a href={socialData.TWITTER} target="_blank">
          {Twitter_Logo}
        </a>
      </li>
      <li>
        <a href={socialData.YOUTUBE} target="_blank">
          {Youtube_Logo}
        </a>
      </li>
      <li>
        <a href={socialData.INSTAGRAM} target="_blank">
          {Instagram_logo}
        </a>
      </li>
    </>
  )

  return (
    <FooterSocial>
      <div className="Footer__SocialNetwork">
        <div>
          {socialData.FOOTER_SOCIAL_INTRO && (
            <Typography className="Footer__SocialNetwork-IntroText" type="body">
              {socialData.FOOTER_SOCIAL_INTRO}
            </Typography>
          )}

          <ul>{langCode === LocaleCodes.CHINESE.code ? CNLogos : logos}</ul>
        </div>
      </div>

      {langCode === LocaleCodes.CHINESE.code ? <WeChatPopUp /> : null}
    </FooterSocial>
  )
}

export default SocialIcons
